var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import commonImageUploader from '../../components/console-common/common-image-uploader.vue';
import addCompany from '../../components/console-common/add-company.vue';
import colorSelect from '../../components/console-common/color-select.vue';
import * as constant from '../../constant/common-type';
import selectCustom from '../../components/console-common/select-custom.vue';
import searchInput from '../../components/console-common/search-input.vue';
import { mapState } from 'vuex';
import eventBus from '../../utils/fresh-table';
import selfTextarea from '../../components/console-common/common-textarea.vue';
import { checkName } from '../../utils/common-utils';
export default Vue.extend({
    created: function () {
        var _this = this;
        this.ruleForm = Object.assign({}, this.vehicleDetail);
        this.imageConfig.imageList.forEach(function (item) {
            item.fileList = _this.ruleForm[item.key];
        });
        switch (this.vehicleDetail.status) {
            case 'DISPOSED':
                this.vehicleStatusOptions = [
                    { label: '在库', val: 'INVENTORY' },
                    { label: '已处置', val: 'DISPOSED' },
                ];
                break;
            case 'INVENTORY':
                this.vehicleStatusOptions = [
                    { label: '已处置', val: 'DISPOSED' },
                    { label: '在库未签约', val: 'INVENTORY' },
                ];
                break;
            default:
                this.vehicleStatusOptions = [
                    { label: '已处置', val: 'DISPOSED' },
                    { label: '已签约', val: 'SIGNED' },
                ];
        }
        if (this.vehicleDetail.purpose === 'OTHER') {
            this.purposeOptions.push({
                label: this.vehicleDetail.purposeText,
                val: 'OTHER',
            });
        }
    },
    components: {
        'el-image-uploader': commonImageUploader,
        'el-add-company': addCompany,
        'el-color-select': colorSelect,
        'el-select-custom': selectCustom,
        'el-search-input': searchInput,
        'el-self-textarea': selfTextarea,
    },
    data: function () {
        return {
            constant: constant,
            purposeOptions: [
                { val: 'JINGZU', label: '经租' },
                { val: 'RONGZU', label: '融租' },
            ],
            imageObj: {},
            purposeConfig: {
                type: 'purpose',
                typeText: 'purposeText',
            },
            imageConfig: {
                url: '/proxy/vehicle/file/file/upload',
                imageList: [
                    {
                        limit: 4,
                        title: '车辆照片',
                        key: 'vehiclePhotos',
                        span: 24,
                        fileList: [],
                    },
                    {
                        limit: 1,
                        title: '网约车证',
                        key: 'onlineLicensePhotos',
                        span: 12,
                        fileList: [],
                    },
                    {
                        limit: 2,
                        title: '行驶证照片',
                        key: 'drivingLicensePhotos',
                        span: 12,
                        fileList: [],
                    },
                ],
            },
            ruleForm: {},
            addCompanyConfig: {
                label: '所属公司',
                title: '添加所属公司',
                type: 'SIGN',
            },
            rules: {
                licensePlateNumber: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' },
                    { min: 7, max: 8, message: '车牌号为7位或者8位', trigger: 'blur' },
                    {
                        pattern: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5,6}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4,5})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
                        message: '车牌号格式不正确',
                        trigger: 'blur',
                    },
                ],
                vehicleIdentificationNumber: [
                    { required: true, message: '请输入车架号', trigger: 'blur' },
                ],
                engineNumber: [
                    { required: true, message: '请输入发动机号', trigger: 'blur' },
                ],
                vehicleModel: [
                    { required: true, message: '请输入车辆型号', trigger: 'blur' },
                    { max: 80, message: '最多输入80个字符', trigger: 'blur' },
                ],
                powered: [
                    { required: true, message: '请选择油电性质', trigger: 'change' },
                ],
                color: [{ required: true, message: '请选择颜色', trigger: 'change' }],
                purpose: [
                    { required: true, message: '请选择车辆用途', trigger: 'change' },
                ],
                remark: [{ max: 100, message: '最多输入100个字', trigger: 'blur' }],
                status: [
                    { required: true, message: '请选择车辆状态', trigger: 'blur' },
                ],
                operator: [{ validator: checkName, trigger: 'blur' }],
            },
        };
    },
    computed: __assign({}, mapState('vehicle', ['vehicleDetail', 'vehicleOperatorList']), mapState({
        vehicle: function (state) { return state.vehicle; },
    })),
    methods: {
        cancel: function () {
            // 取消
            this.$store.commit('vehicle/update', {
                showVehicleEditDialog: false,
            });
        },
        save: function () {
            var _this = this;
            // 请求接口
            this.$refs.ruleForm.validate(function (valid) {
                if (valid) {
                    _this.$refs.imageUpload.forEach(function (item) {
                        var key = item.imageObj.key;
                        _this.imageObj[key] = item._data.uploadKeys.join(',');
                    });
                    var params = __assign({ vehicleCode: _this.ruleForm.vehicleCode, licensePlateNumber: _this.ruleForm.licensePlateNumber, vehicleIdentificationNumber: _this.ruleForm
                            .vehicleIdentificationNumber, engineNumber: _this.ruleForm.engineNumber, color: _this.ruleForm.color, purpose: _this.ruleForm.purpose, purposeText: _this.ruleForm.purposeText, subjection: _this.ruleForm.subjection, powered: _this.ruleForm.powered, purchaseTime: _this.ruleForm.purchaseTime, licenseTime: _this.ruleForm.licenseTime, operator: _this.ruleForm.operator, remark: _this.ruleForm.remark, status: _this.ruleForm.status, vehicleModel: _this.ruleForm.vehicleModel }, _this.imageObj);
                    _this.$request({
                        url: '/proxy/vehicle/driver/vehicle/update',
                        method: 'post',
                        data: params,
                    }).then(function (res) {
                        if (!res.errorCode) {
                            _this.$message({
                                message: '更新成功',
                                type: 'success',
                            });
                            _this.$store.commit('vehicle/update', {
                                showVehicleEditDialog: false,
                            });
                            eventBus.$emit('freshTable');
                        }
                    });
                }
                else {
                    return false;
                }
            });
        },
    },
});
